import { useAuthToggles } from "./useAuthToggles";

export const useHideLogoutSankhyaRh = authUrl => {
  const { data, isLoading } = useAuthToggles(authUrl);

  return {
    hideLogoutSankhyaRh: data?.t004_hide_logout_sankhyarh ?? false,
    isLoading
  };
};
